/* ============================= E X P O R T ============================= */

export default {
  name: 'Delete',

  props: {
    color: {
      type: String,
      in: [
        'primary',
        'secundary'
      ]
    }
  }
}
